import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import ResetPasswordIndexController from 'cio/pods/reset-password/index/controller';

export default class ResetPasswordIndexRoute extends Route {
  setupController(controller: ResetPasswordIndexController, model: Record<string, any>, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaultProperties();
  }
}
